<template id='my-template'>
  <div class='container-timeline'>
    <input v-model='searchQuery' class='search-box' placeholder='Search for articles...'>
    <div class='timeline' v-if='anyArticle()'>
      <div v-for='(dateWithArticles,date) in searchedArticles'>
      <p v-if='dateWithArticles.length > 0' class='date'>{{ date }}</p>
        <div v-for='article in dateWithArticles' class='article' @click="">
          <span class='dot'></span>
          <p class='article-date'>{{ article.Employee}}</p>
          <h3><router-link tag="a" :to="{path: '/stacks/timeline/timelinefullinfo', query: { purpose: article.Purpose, employee: article.Employee, date:date, stackname: $route.query.stacknamehistory}}" key="link_stackusage">
                {{ article.Purpose }}
              </router-link></h3>
          <p>{{ article.Branch }}</p>
      </div>
    </div>
    </div>
    <p v-else>No History found.</p>
  </div>
</template>
<script>
   import http from "../http-common"
  export default {
    name: 'Timeline',
    data() {
      return{
        datesArticles: {},
        searchQuery: '',
        data:{}
      }},
  computed: {
    searchedArticles: function searchedArticles() {
      var searchRegex = new RegExp(this.searchQuery, 'i')
      var searchedObj = {}

      if (this.searchQuery == '') {
        return this.datesArticles
      }
        for(var date in this.datesArticles){
        searchedObj[date] = this.datesArticles[date].filter(function (article) {
          return searchRegex.test(article.Employee) ||
          searchRegex.test(article.Purpose) ||
          searchRegex.test(article.Branch) ||
          searchRegex.test(date)
        });
      }
      return searchedObj;
    } },

  methods: {
    anyArticle: function anyArticle() {
      return this.countAllArticles() ? true : false;
    },
    countAllArticles: function countAllArticles() {
      var count = 0;
      for (var date in this.searchedArticles) {
        count += this.searchedArticles[date].length
      }
      return count;
    },
    async getstacktimeline(){
        await http
        .post("/timeline", this.$route.query.stacknamehistory)
        .then(response => {
          var dataset={}
          for(var data in response.data){
            var obj={
              Employee:response.data[data].employee,
              Purpose:response.data[data].purpose,
              Branch:response.data[data].branch
            };
            dataset[response.data[data].startdate] = dataset[response.data[data].startdate] || []
            dataset[response.data[data].startdate].push(obj)        
          }
          this.datesArticles=dataset
        })
        .catch(e => {
          console.log(e)
        });
        
      }
     },
     created(){
      this.getstacktimeline()
     }  
    }

</script>
<style>

* {
  outline: none;
  box-sizing: border-box;
}

.container-timeline {
  margin: 0 auto;
  width: 100%;
  max-width: 500px;
}
.container-timeline  .search-box {
  padding: 10px;
  margin: 20px 0;
  border: 1px solid black;
  border-radius: 5px;
}
.container-timeline  .timeline {
  position: relative;
  border-left: 1px solid black;
}
.container-timeline  .timeline .date {
  display: inline-block;
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
  position: relative;
  left: 15px;
  margin: 15px 0;
}
.container-timeline  .timeline .date:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -16px;
  border: 1px solid black;
  width: 14px;
}
.container-timeline  .timeline .article {
  position: relative;
  left: 20px;
  background-color: #fff;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
}
.container-timeline  .timeline .article:hover {
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.4);
}
.container-timeline  .timeline .article a {
  color: green;
  text-decoration: none;
}
.container-timeline  .timeline .article .article-date {
  font-weight: 300;
  font-size: 14px;
}
.container-timeline  .timeline .article .dot {
  display: block;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: green;
  left: -25.5px;
  top: calc(50% - 5px);
}
  </style>